import {
  GET_AVAILABLEDEPARTMENTS_REQUESTED,
  GET_AVAILABLEDEPARTMENTS_SUCCESS,
  GET_WORKSESSION_REQUESTED,
  GET_WORKSESSION_SUCCESS,
  DASHBOARD_FAILED,
  DASHBOARD_RESET,
} from './actionTypes'

export const getAvailableCashboxes = () => ({ type: GET_AVAILABLEDEPARTMENTS_REQUESTED })

export const getAvailableCashboxesSuccess = payload => ({
  type: GET_AVAILABLEDEPARTMENTS_SUCCESS,
  payload,
})

export const selectionWorkSession = payload => ({
  type: GET_WORKSESSION_REQUESTED,
  payload,
})

export const selectionWorkSessionSuccess = payload => ({
  type: GET_WORKSESSION_SUCCESS,
  payload
})

export const returnFailed = payload => ({
  type: DASHBOARD_FAILED,
  payload,
})

export const dashboardReset = () => ({
  type: DASHBOARD_RESET
})
